import { orderCompaniesAndStations } from "helpers/companiesNormalized";
import { getStations } from "helpers/companiesNormalized";
import { convertToObjById } from "helpers/convertToObject";
import { orderArrayV2 } from "helpers/orderArray";

export const LOAD_COMPANIES_V2 = "LOAD_COMPANIES_V2";
export const SET_COMPANIES_V2 = "SET_COMPANIES_V2";
export const STATIONS_BY_COMPANIES = "STATIONS_BY_COMPANIES";
export const SET_COMPANIES_GOD = "SET_COMPANIES_GOD";
export const CHANGE_STATION_CONFIGURATIONS = 'CHANGE_STATION_CONFIGURATIONS';

const initialState = {
  loading: false,
  companies: {},
  companiesList: [],
  stations: {},
  stationsList: [],
  stationsObj: {},
  error: null,
  companiesGod: [],
  stationsGod: []
};

export const companiesReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOAD_COMPANIES_V2:
      return {
        ...state,
        loading: true
      };

    case SET_COMPANIES_V2:
      const addingLabel = action.payload.map((company) => {
        return {
          ...company,
          stations: company.stations.map((station) => {
            return {
              ...station,
              label: station.name,
              value: station.id,
              company: company.name,
              fullName: `${company.name} - ${station.name}`
            };
          })
        };
      });
      const companies = orderCompaniesAndStations(addingLabel);

      return {
        ...state,
        companies: convertToObjById(addingLabel),
        stations: convertToObjById(getStations(addingLabel)),
        stationsList: orderArrayV2(
          addingLabel.map(a => a.stations).flat(),
          "name"
        ),
        companiesList: companies.sort((a, b) => a.name.localeCompare(b.name)),
        loading: false
      };

    case CHANGE_STATION_CONFIGURATIONS: 
      const findIndx = state.stationsList.findIndex(
        station => station?.id === action.payload?.id
      );

      const findIndxComp = state.companiesList.findIndex(
        company => company?.id === action.payload?.id_company
      )

      return {
        ...state,
        stationsList: state.stationsList.map((station, i) =>
          i === findIndx ? { ...station, ...action.payload } : station
        ),
        stations: {
          ...state.stations,
          [action.payload.id]: {
            ...state.stations[action.payload.id],
            ...action.payload,
          },
        },
        companiesList: state.companiesList.map((company, i) => 
          i === findIndxComp ? {...company, 
            stations: company.stations.map((station) =>
              station.id === action.payload.id ? { ...station, ...action.payload } : station
            )
          } : company
        ),
      }
    
    case STATIONS_BY_COMPANIES:
      return {
        ...state,
        stationsByCompanies: state.companies.filter(
          item => item.id === action.payload
        )[0].stations
      };

    case SET_COMPANIES_GOD: {
      const companiesGod = orderCompaniesAndStations(action.payload);
      const stationsGod = orderArrayV2(getStations(action.payload), "name");
      return {
        ...state,
        stationsGod: stationsGod,
        companiesGod: companiesGod.sort((a, b) => a.name.localeCompare(b.name))
      };
    }
    default:
      return state;
  }
};
